import { PriorityValue } from '@/shared/enums';

export const priorityStyles = (
  value: PriorityValue,
): { bgColor: string; textColor: string } => {
  switch (value) {
    case PriorityValue.VeryLow:
      return { bgColor: 'bg-green-400', textColor: 'text-green-400' };
    case PriorityValue.Low:
      return { bgColor: 'bg-green', textColor: 'text-green' };
    case PriorityValue.Medium:
      return { bgColor: 'bg-yellow', textColor: 'text-yellow' };
    case PriorityValue.High:
      return { bgColor: 'bg-red-400', textColor: 'text-red-400' };
    case PriorityValue.Critical:
      return { bgColor: 'bg-red', textColor: 'text-red' };
    default:
      return { bgColor: '', textColor: '' };
  }
};
